import React from "react";
import { Link } from "react-router-dom";
import EventCard from "./EventCard";

const EventCarousel = ({ events, title }) => {
  return (
    <div className="mt-6 sm:mt-8 md:mt-12">
      <div className="flex items-center justify-between mt-[20px] sm:mt-[30px] md:mt-[38px] mb-[20px] sm:mb-[30px] md:mb-[40px]">
        <h2 className="text-white font-['Poppins'] text-[16px] sm:text-[18px] md:text-[20px] leading-[24px] sm:leading-[27px] md:leading-[30px] font-medium">
          {title}
        </h2>
        <Link to="/events-filters">
          <button 
            className="bg-transparent border border-white text-white font-medium transition-all duration-300 hover:bg-white/5 text-xs sm:text-sm flex justify-center items-center px-3 sm:px-4 md:px-6 py-1 sm:py-1.5 md:py-2 rounded-full sm:rounded-[20px]"
          >
            View All
          </button>
        </Link>
      </div>
      
      <div className="flex gap-3 sm:gap-4 md:gap-6 overflow-x-auto pb-4 scrollbar-hide">
        {events.slice(0, 5).map((event, index) => (
          <EventCard key={`${event.id}-${index}`} event={event} />
        ))}
      </div>
    </div>
  );
};

export default EventCarousel; 